import { useEffect, useState } from "react";

/**
 * `value` once it has stayed the same for `delay` milliseconds: the first value at once, and each later one only after
 * that long without another. What a request that costs something follows, where every keystroke would be too many.
 */
export function useSettled<T>(value: T, delay: number): T {
	const [settled, setSettled] = useState(value);
	useEffect(() => {
		const timer = setTimeout(() => {
			setSettled(value);
		}, delay);
		return () => {
			clearTimeout(timer);
		};
	}, [value, delay]);
	return settled;
}
